import { API_BASE_URL } from "../config/apiConfig";

const getAuthToken = () => {
  return (
    localStorage.getItem(
      "zethAuthToken"
    ) ||
    sessionStorage.getItem(
      "zethAuthToken"
    )
  );
};

const clearAuthentication = () => {
  localStorage.removeItem(
    "zethAuthToken"
  );

  localStorage.removeItem(
    "zethUser"
  );

  sessionStorage.removeItem(
    "zethAuthToken"
  );

  sessionStorage.removeItem(
    "zethUser"
  );
};

const getLoginPath = () => {
  const pathname =
    window.location.pathname;

  if (
    pathname.startsWith("/admin")
  ) {
    return "/admin/login";
  }

  if (
    pathname.startsWith("/facility")
  ) {
    return "/facility/login";
  }

  return "/professional/login";
};

const parseResponse = async (
  response
) => {
  const contentType =
    response.headers.get(
      "content-type"
    );

  if (
    !contentType?.includes(
      "application/json"
    )
  ) {
    return null;
  }

  return response
    .json()
    .catch(() => null);
};

const request = async (
  endpoint,
  options = {}
) => {
  const token =
    getAuthToken();

  const isFormData =
    options.body instanceof
    FormData;

  const headers = {
    ...(isFormData
      ? {}
      : {
          "Content-Type":
            "application/json",
        }),

    ...(token
      ? {
          Authorization:
            `Bearer ${token}`,
        }
      : {}),

    ...(options.headers || {}),
  };

  let response;

  try {
    response = await fetch(
      `${API_BASE_URL}${endpoint}`,
      {
        ...options,
        headers,
      }
    );
  } catch (networkError) {
    const error = new Error(
      "Unable to connect to the server."
    );

    error.status = 0;
    error.cause = networkError;

    throw error;
  }

  const data =
    await parseResponse(
      response
    );

  if (
    response.status === 401
  ) {
    clearAuthentication();

    const error = new Error(
      data?.message ||
        "Your session has expired."
    );

    error.status = 401;
    error.data = data;

    window.location.href =
      getLoginPath();

    throw error;
  }

  if (!response.ok) {
    const error = new Error(
      data?.message ||
        "The request could not be completed."
    );

    error.status =
      response.status;

    error.data = data;

    throw error;
  }

  return data;
};

const api = {
  get(endpoint, options = {}) {
    return request(
      endpoint,
      {
        method: "GET",
        ...options,
      }
    );
  },

  post(
    endpoint,
    body,
    options = {}
  ) {
    return request(
      endpoint,
      {
        method: "POST",

        body:
          body instanceof FormData
            ? body
            : JSON.stringify(
                body
              ),

        ...options,
      }
    );
  },

  put(
    endpoint,
    body,
    options = {}
  ) {
    return request(
      endpoint,
      {
        method: "PUT",

        body:
          body instanceof FormData
            ? body
            : JSON.stringify(
                body
              ),

        ...options,
      }
    );
  },

  patch(
    endpoint,
    body,
    options = {}
  ) {
    return request(
      endpoint,
      {
        method: "PATCH",

        body:
          body instanceof FormData
            ? body
            : JSON.stringify(
                body
              ),

        ...options,
      }
    );
  },

  delete(
    endpoint,
    options = {}
  ) {
    return request(
      endpoint,
      {
        method: "DELETE",
        ...options,
      }
    );
  },

  request,

  getAuthToken,
  clearAuthentication,
};

export default api;
